import IconPdf from '@fortuneo/ui-icons/specials/IconPdf'
import { withDisplayName } from '@hocs/with-display-name'
import { useGetDynamicDomainLink } from '@hooks/use-get-dynamic-domain-link'
import { useTrackExternalLink } from '@hooks/use-track-external-link'
import { ENHANCED_COMPONENT_TYPE } from '@ui/enhanced-components/types'
import { isIosWebview } from '@utils/is-webview'
import clsx from 'clsx/lite'
import { graphql } from 'gatsby'
import React from 'react'

const ContentfulPDFLink: Utils.EntryFC<Queries.ContentfulPDFLinkFragment> = ({
  content: { url },
  children,
  fieldInspectorProps,
}) => {
  const trackExternalLink = useTrackExternalLink()
  const getDynamicPrivateLink = useGetDynamicDomainLink('private')

  return (
    <a
      {...fieldInspectorProps({
        fieldId: 'url',
      })}
      data-type={ENHANCED_COMPONENT_TYPE.HYPERLINK}
      href={getDynamicPrivateLink(url)}
      rel={isIosWebview() ? '' : 'noreferrer'}
      target={isIosWebview() ? '_self' : '_blank'}
      className={clsx(
        'text-theme-info-main!',
        'hover:text-theme-selected-accent3 hover:underline',
        'group-[.is-blue]/section-template:text-text-inverse!',
        'group-[.is-blue]/component:text-text-inverse!',
        'group-[.is-blue]/section-template:hover:text-theme-info-accent1!',
        'group-[.is-blue]/component:hover:text-theme-info-accent1!'
      )}
      onClick={trackExternalLink}
    >
      <IconPdf className="fill-theme-info-main! group-[.is-blue]/section-template:fill-text-inverse! mr-2 inline-block align-middle" />
      {children}
    </a>
  )
}

export const query = graphql`
  fragment ContentfulPDFLink on ContentfulPdfLink {
    ...ContentfulEntry
    url
  }
`

export default withDisplayName(ContentfulPDFLink, 'ContentfulPDFLink')
